import "./about.css";
import dot from "../../assets/images/About/about-dots.png";
import award from "../../assets/images/About/Award.png";
import about from "../../assets/images/About/About.jpg";
import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";

export default function About() {
  const countRef = useRef(null);
  const isInView = useInView(countRef, { once: true, amount: 0.5 });

  // motion value for counting
  const count = useMotionValue(0);
  const rounded = useTransform(count, latest => Math.floor(latest));

  useEffect(() => {
    if (isInView) {
      const controls = animate(count, 20, {
        duration: 2,
        ease: "easeOut",
      });
      return controls.stop;
    }
  }, [isInView, count]);

  return (
    <section className="about-two">
      <div className="auto-container">
        <div className="row clearfix">
          {/* Image Column */}
          <div className="about-two_image-column col-lg-6 col-md-12 col-sm-12">
            <motion.div
              className="about-two_image-inner"
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <div className="about-two_image" ref={countRef}>
                {/* Counter Column */}
                <div className="about-two_counter-block">
                  <div
                    className="dots-layer"
                    style={{ backgroundImage: `url(${dot})` }}
                  />
                  <div className="about-two_counter-number">
                    <motion.span>{rounded}</motion.span>+
                  </div>
                  <div className="about-two_counter-text">
                    Years of <br /> Experience
                  </div>
                </div>

                <img src={about} alt="" />

                <div className="about-two_award">
                  <div className="about-two_award-inner">
                    <div className="about-two_award-icon">
                      <img src={award} alt="" />
                    </div>
                    <strong>Best Software Development Company</strong>
                   Leading Website, ERP/CRM, Mobile Application Company in Ahmedabad
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Content Column */}
          <div className="about-two_content-column col-lg-6 col-md-12 col-sm-12">
            <motion.div
              className="about-two_content-inner"
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <div className="sec-title style-two">
                <div className="sec-title_title">About us</div>
                <h2 className="sec-title_heading">
                Horizon Webinfo Pvt. Ltd. – Trusted IT & Odoo ERP Development Company in India
                </h2>
                <div className="sec-title_text">
                 <span>Horizon Webinfo Pvt. Ltd.</span> is a reliable and experienced <span> IT solutions and software development company in India,</span> helping businesses simplify operations, improve productivity, and grow digitally. Based in Ahmedabad, we serve clients across India with <span>custom software development, Odoo ERP solutions, website development, mobile apps, and ongoing IT support.</span>

                </div>
                <div className="sec-title_text">
                 With <span>20+ years of industry experience,</span> we understand Indian business processes and deliver practical, cost-effective, and scalable technology solutions.
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
